import { render, staticRenderFns } from "./questionBankItem.vue?vue&type=template&id=60e68a39&scoped=true&"
import script from "./questionBankItem.vue?vue&type=script&lang=js&"
export * from "./questionBankItem.vue?vue&type=script&lang=js&"
import style0 from "./questionBankItem.vue?vue&type=style&index=0&id=60e68a39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e68a39",
  null
  
)

export default component.exports